var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "settings-container" } },
    [
      _c("notifications-page", {
        ref: "notifications",
        attrs: {
          loading: _vm.loading,
          "notification-preferences": _vm.notificationPreferences,
          "hide-all-web": false,
          source: "broker",
        },
        on: { submit: _vm.handleSubmit, "allow-save": _vm.handleAllowSave },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }